import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import RouterIpAddressBody from './RouterIpAddressBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import RouterIpAddressProvider from './context/RouterIpAddressProvider';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const RouterIpAddress = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`,`${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <RouterIpAddressProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - Router IP Address" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <RouterIpAddressBody />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </RouterIpAddressProvider>
    </div>
  );
};

export default RouterIpAddress;
